











import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import Icon from '../Icon.vue'
import { IResidentPaymentMethod } from '@zunta/configurations'

@Component({
  components: { Icon },
  props: {
    paymentMethod: {
      type: Object as PropType<IResidentPaymentMethod> || null,
      required: true
    }
  }
})
export default class PaymentMethodLabel extends Vue {
  get isPaymentMethod () {
    return !!this.$props.paymentMethod
  }

  get isActive () {
    return this.isPaymentMethod && this.$props.paymentMethod.active
  }

  get paymentMethodText () {
    if (!this.isPaymentMethod) {
      return 'Removed'
    }
    return `${this.$props.paymentMethod.brandName === 'ECheck'
      ? `eCheck **** ${this.$props.paymentMethod.last4Digits}`
      : `CC **** ${this.$props.paymentMethod.last4Digits}`}`
  }
}
